/** @typedef {import('./ServiceProvider.svc')} Types */

export class ServiceProvider {
	constructor($http, API, PUBLIC_KEY) {
		'ngInject';
		this.API = API;
		this.PUBLIC_KEY = PUBLIC_KEY;
		this.http = $http;
		this.v1 = '/v1';
		this.v2 = '/v2';
		this.gate = '/serviceProvider';
	}

	/** @param {Types.GetAllServiceProvidersParams} params */
	getAllServiceProviders(params, cache = false) {
		return this.http.get(`${this.API}${this.gate}/allServiceProviders`, {params, cache});
	}

	/** @param {Types.GetProposalLabelsByProviderIdParams} params */
	getProposalLabelsByProviderId(params, cache = false) {
		return this.http.get(`${this.API}${this.gate}/proposalLabelsByProviderId`, {params, cache});
	}

	/** @param {Types.UpdateProposalLabelsByProviderIdParams} params */
	updateProposalLabelsByProviderId(params) {
		return this.http.post(`${this.API}${this.gate}/updateProposalLabelsByProviderId`, params);
	}

	/** @param {Types.GetServiceProviderDetailsParams} params */
	getServiceProviderDetails(params, cache = false) {
		return this.http.get(`${this.API}${this.gate}/serviceProviderDetails`, {params, cache});
	}

	/** @param {Types.GetServiceProviderDetailsExcerptParams} params */
	getServiceProviderDetailsExcerpt(params, cache = false) {
		const headers = {Auth: this.PUBLIC_KEY};
		return this.http.get(`${this.API}${this.v2}${this.gate}/serviceProviderDetailsExcerpt`, {
			params,
			cache,
			headers,
		});
	}

	/** @param {Types.GetAllEconomicProfileSettingsByServiceProviderParams} params */
	getAllEconomicProfileSettingsByServiceProvider(params, cache = false) {
		return this.http.get(`${this.API}${this.gate}/allEconomicProfileSettingsByServiceProvider`, {
			params,
			cache,
		});
	}

	/** @param {Types.GetAllCommissionTiersParams} params */
	getAllCommissionTiers(params, cache = false) {
		return this.http.get(`${this.API}${this.gate}/allCommissionTiers`, {params, cache});
	}

	/** @param {Types.GetBusinessUnitsParams} params */
	getBusinessUnits(params, cache = false) {
		return this.http.get(`${this.API}${this.gate}/businessUnits`, {params, cache});
	}

	/** @param {Types.GetAllEmailTemplatesByServiceProviderParams} params */
	getAllEmailTemplatesByServiceProvider(params, cache = false) {
		return this.http.get(`${this.API}${this.gate}/allEmailTemplatesByServiceProvider`, {params, cache});
	}

	/** @param {Types.GetAllEmailTemplateAttributesParams} params */
	getAllEmailTemplateAttributes(params, cache = false) {
		return this.http.get(`${this.API}${this.gate}/allEmailTemplateAttributes`, {params, cache});
	}

	/** @param {Types.GetFeatureflagsParams} params */
	getFeatureflags(params, cache = false) {
		return this.http.get(`${this.API}${this.gate}/featureflags`, {params, cache});
	}

	/** @param {Types.GetFeatureFlagsForCustomerParams} params */
	getFeatureFlagsForCustomer(params, cache = false) {
		const headers = {Auth: this.PUBLIC_KEY};
		return this.http.get(`${this.API}${this.gate}/featureFlagsForCustomer`, {params, cache, headers});
	}

	/** @param {Types.UpdateEmailTemplateAttributesParams} params */
	updateEmailTemplateAttributes(params) {
		return this.http.post(`${this.API}${this.gate}/updateEmailTemplateAttributes`, params);
	}

	/** @param {Types.GetSeriesParams} params */
	getSeries(params, cache = false) {
		return this.http.get(`${this.API}${this.gate}/series`, {params, cache});
	}

	/** @param {Types.PostUpdateSeriesPreferencesParams} params */
	postUpdateSeriesPreferences(params) {
		return this.http.post(`${this.API}${this.gate}/updateSeriesPrefererences`, params);
	}

	/** @param {Types.UpdateEconomicProfileSettingsByServiceProviderParams} params */
	updateEconomicProfileSettingsByServiceProvider(params) {
		return this.http.post(`${this.API}${this.gate}/updateEconomicProfileSettingsByServiceProvider`, params);
	}

	/** @param {Types.PostCreateCommissionTierParams} params */
	postCreateCommissionTier(params) {
		return this.http.post(`${this.API}${this.gate}/createCommissionTier`, params);
	}

	/** @param {Types.PostUpdateCommissionTierParams} params */
	postUpdateCommissionTier(params) {
		return this.http.post(`${this.API}${this.gate}/updateCommissionTier`, params);
	}

	/** @param {Types.PostDeleteCommissionTierParams} params */
	postDeleteCommissionTier(params) {
		return this.http.post(`${this.API}${this.gate}/deleteCommissionTier`, params);
	}

	/** @param {Types.PostUpdateProviderParams} params */
	postUpdateProvider(params) {
		return this.http.post(`${this.API}${this.gate}/update`, params);
	}

	/** @param {Types.GetProviderConnectorParams} params */
	getProviderConnector(params, cache = false) {
		return this.http.get(`${this.API}${this.gate}/providerCustomConnector`, {params, cache});
	}
}
//
let compMod = angular
	.module('mod.svc.ServiceProviderService', [])
	.service('ServiceProviderService', ServiceProvider);
export default (compMod = compMod.name);
